export default __webpack_public_path__ + "static/media/recenter.97575f01.svg";